import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// Meta Pixel
;
(function () {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode?.insertBefore(t, s);
})();
(window as any).fbq('init', '1971698440105545');
(window as any).fbq('track', 'PageView');
// Noscript fallback
const noscriptImg = document.createElement('img');
noscriptImg.height = 1;
noscriptImg.width = 1;
noscriptImg.style.display = 'none';
noscriptImg.src = 'https://www.facebook.com/tr?id=1971698440105545&ev=PageView&noscript=1';
document.body.appendChild(noscriptImg);
render(<App data-id="element-237" />, document.getElementById('root'));